import {
  arrayCascade,
  getQITMeetingTimeline, getRecentQITMeetingTimeline,
} from "./tools";
import {ADOPTION_TARGET} from "./consts";
import {fetchLocations} from "../factories/locations";
import * as DHTStates from "../helpers/DHTStates";
import * as FacilityAStates from "../helpers/FacilityAStates";
import * as FacilityBStates from "../helpers/FacilityBStates";
import * as FacilityCStates from "../helpers/FacilityCStates";

export default class StakeholderDetails {
  constructor(history, location, stakeholder) {
    this.stakeholder = stakeholder;
    this.history = history;
    this.location = location;
  }

  getHTML(lazy = 0) {
    let FacilityStates;
    let stakeholderTitle;
    if (this.location.id === 'DHT') {
      FacilityStates = DHTStates;
      stakeholderTitle = this.stakeholder.title;
    }
    if (this.location.id === 'FacilityA') {
      FacilityStates = FacilityAStates;
    }
    if (this.location.id === 'FacilityB') {
      FacilityStates = FacilityBStates;
    }
    if (this.location.id === 'FacilityC') {
      FacilityStates = FacilityCStates;
    }

    const history = this.history;
    const location = this.location;

    if (history.length) {
      const timelineNotes = [];
      let adoptionTargetReached = false;
      let i = 0, len = history.length;
      while (i < len) {
        let context;
        const timeline = history.slice(0, i+1);
        const action = timeline[timeline.length -1];
        if (action.id === "I1") {
          context = new FacilityStates.AfterInterviewsState(timeline, location);
        }
        if (action.id === "D1") {
          context = new FacilityStates.FromDataAnalysisState(timeline, location);
        }
        if (action.id === "C4") {
          context = new FacilityStates.GoAndSeeState(timeline, location);
        }
        if (!adoptionTargetReached) {
          const pureLocations = fetchLocations(timeline, timeline.slice(0, timeline.length -1));
          const pureLocation = pureLocations.find(each => each.id === location.id);
          if (pureLocation.adoption >= ADOPTION_TARGET) {
            context = new FacilityStates.WhenReaches80PercentAdoptionState(timeline, location);
            adoptionTargetReached = true;
          }
        }
        const note = context && context.getStakeholderState(this.stakeholder);
        note && timelineNotes.findIndex(each => each.data === note.data) < 0 && timelineNotes.push(note);
        i++;
      }

      const {allMeetings, successfulMeetingIndex, microplanningMeetingIndex} = getQITMeetingTimeline(history, location);

      const qitMeetingNotes = [];
      i = 0;
      len = allMeetings.length;
      
      while (i < len) {
        debugger
        let context;
        const timeline = allMeetings[i];
        if (i !== microplanningMeetingIndex) {
          if (successfulMeetingIndex === i) {
            context = new FacilityStates.FirstSuccessfulQITMeetingState(timeline, location, lazy);
          } else if (successfulMeetingIndex === (i -1)) {
            context = new FacilityStates.FollowupQITMeetingState(timeline, location, lazy);
          } else {
            context = new FacilityStates.QITMeetingState(timeline, location, lazy);
          }
        } else {
          context = new FacilityStates.MicroPlanningMeetingState(timeline, location, lazy);
        }
        const note = context && context.getStakeholderState(this.stakeholder);
        note && qitMeetingNotes.push(note);
        i++;
      }

      const notes = [...timelineNotes, ...qitMeetingNotes]
        .sort((a, b) => {
          if ( a.week < b.week ){
            return -1;
          }
          if ( a.week > b.week ){
            return 1;
          }
          return 0;
        })
        .map(each => (
          `<p class="text-lg lg:text-2xl font-bold mb-5">${each.title}</p>
          ${each.data}
          <div class="h-20"></div>`
        ))
        .reverse()
        .join('');
      if (notes.length === 0) return this._templatePlaceholder();
      return this._templateHTML(notes, stakeholderTitle);
    } else {
      return this._templatePlaceholder();
    }
  }

  /**
   *
   * @param title
   * @returns {string}
   * @private
   */
  _templatePlaceholder(title) {
    const locationName = this.location ? this.location.name : "";
    const stakeholderTitle = this.stakeholder.title === "Community"
      ? this.location.name
      : title || `${locationName} ${this.stakeholder.title}`;
    return `
    <div class="w-full lg:w-10/12 mx-auto flex flex-col justify-center">
      <img src="${this.stakeholder.img}" alt="" class="w-32 lg:w-40 mt-6"/>
      <div class="h-48">
        <p class="text-lg lg:text-2xl font-bold my-2">
          ${stakeholderTitle}
        </p>
        <p class="leading-tight">
          To learn more about this person’s opinion of the change, you will need to send a team to gather additional information.
        </p>
      </div>
    </div>`
  }

  /**
   *
   * @param notes
   * @param stakeholderTitle
   * @returns {string}
   * @private
   */
  _templateHTML(notes, stakeholderTitle) {
    const locationName = this.location ? this.location.name : "";
    const isTitleCommunity = this.stakeholder.title === "Community";
    const content = isTitleCommunity
      ? `
      <div class="sticky top-0">
        <div class="flex flex-col items-center w-32 lg:w-40">
          <img src="${this.stakeholder.img}" alt="" class="w-full mt-6"/>
          <p class="text-lg lg:text-2xl font-bold my-2">
            ${this.location.name}
          </p>
        </div>
      </div>`
      : `
      <div class="sticky top-0">
        <div class="flex items-center">
          <img src="${this.stakeholder.img}" alt="" class="w-32 lg:w-40 mt-6"/>
          <ul class="text-xs pl-2 transform translate-y-3">
            <li class="mb-2">
              <div class="bg-white rounded-full p-px border-white border w-24 lg:w-40">
                <div class="bg-brand-orange-500 rounded-full p-1 border-2 border-brand-orange-500" style="width: ${this.stakeholder.motivation}%">
                </div>
              </div>
              <p class="px-2 py-px">
                Motivation: ${this.stakeholder.motivation}%
              </p>
            </li>
            <li>
              <div class="bg-white rounded-full p-px border-white border w-24 lg:w-40">
                <div class="bg-brand-teal-500 rounded-full p-1 border-2 border-brand-teal-500" style="width: ${this.stakeholder.ability}%">
                </div>
              </div>
              <p class="px-2 py-px">
                Abilities: ${this.stakeholder.ability}%
              </p>
            </li>
          </ul>
        </div>
        <p class="text-lg lg:text-2xl font-bold my-2">
          ${stakeholderTitle || (locationName + " " + this.stakeholder.title)}
        </p>
      </div>`;
    return `
    <div class="w-full lg:w-10/12 mx-auto flex flex-col justify-center">
      <div class="flex flex-col lg:flex-row">
        <div class="${isTitleCommunity ? 'lg:w-1/3' : 'lg:w-1/2'} py-12 relative">
          ${content}
        </div>
        <div class="${isTitleCommunity ? 'lg:w-2/3' : 'lg:w-1/2'} overflow-y-auto py-12">
          ${notes}
        </div>
      </div>
    </div>`
  }
}
